import { Component } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';
import { ManualCreationCargoService } from '../manual-creation-cargo/manual-creation-cargo.service';
import { Permission } from 'src/app/core/resources/permission';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-cargo-tabs-create',
  templateUrl: './cargo-tabs-create.component.html',
  styleUrls: ['./cargo-tabs-create.component.scss'],
  providers: [AuthService, Global, DatePipe]
})

export class CargoCreateTabsComponent {
  // DatePicker
  displayMonths = 2;
  navigation = 'select';
  showWeekNumbers = false;
  outsideDays = 'visible';
  showListLatestRequests = false;
  permission = Permission;
  tabs: { alias: string, permission: string, component: string }[] = [
    { alias: 'Solicitud', permission: this.permission.cargo.createCargoRequest, component: 'app-create-cargo' },
    { alias: 'Masivas', permission: this.permission.cargo.createMassiveCargo, component: 'app-mass-creation-cargo' },
    { alias: 'Desde una ruta', permission: this.permission.cargo.createCargoFromRoute, component: 'app-upload-route' },
    { alias: 'Manual', permission: this.permission.cargo.createManualCargo, component: 'app-upload-download-map-freight' },
    { alias: "Servicio de escolta", permission: this.permission.cargo.createEscortService, component: 'app-create-escort-service' },
    { alias: "Servicio de candado satelital", permission: this.permission.cargo.createSatelliteLockService, component: 'app-create-satellite-lock-service' }
  ]
  selectedTabIndex: number = 0;

  constructor(
    public manualCreationCargoService: ManualCreationCargoService,
    private authService: AuthService
  ) { }

  onSelectTab(index: number) {
    this.selectedTabIndex = index;
  }

  get permissions(): string[] {
    return this.tabs.map(tab => tab.permission);
  }

}
